export const SET_POLICIE_DATA = "policieActions::setPolicieData";
export const SET_UNCONFIRMED_POLICIE_DATA =
  "policieActions::setUnconfirmedPolicieData";
export const SET_POLICIE_OPEN = "policieActions::setPolicieOpen";

export const setPolicieData = payload => {
  return {
    type: SET_POLICIE_DATA,
    payload
  };
};

export const setUnconfirmedPolicieData = payload => {
  return {
    type: SET_UNCONFIRMED_POLICIE_DATA,
    payload
  };
};

export const setPolicieOpen = payload => {
  return {
    type: SET_POLICIE_OPEN,
    payload
  };
};
